module.exports = __webpack_public_path__ + "static/media/Maintennace.3a58991b.svg";